<template>
    <section class="c-login">
        <div class="c-login__body">

            <app-intro class="u-d-flex justify-content-center">
                <h1 class="beta">Nieuw wachtwoord</h1>
            </app-intro>

            <forgot-password-reset-form/>

        </div>
    </section>
</template>

<script>
    import AppIntro from '../../components/app/AppIntro.vue';
    import ForgotPasswordResetForm from '../../components/forms/ForgotPasswordResetForm.vue';

    export default {
        components: { ForgotPasswordResetForm, AppIntro },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .c-login {
        display: grid;
        height: 100%;

        &__body {
            align-self: center;
            justify-self: center;

            @include media-breakpoint-up(md) {
                margin: 0 auto;
                width: grid(12, lg);
            }
        }
    }
</style>
